module.exports = __webpack_public_path__ + "img/5.80526ee4.jpg";